import './App.css';
import Home from './views';

function App() {
  return (
    <div className="w-full h-screen flex items-center justify-center">
      <Home/>
    </div>
  );
}

export default App;
